<template>
  <div class="hs-popup-mask-box" @click="_close">
    <transition name="hs-popup-mask">
      <div class="hs-popup-mask" v-show="currentValue"></div>
    </transition>
    <transition name="datepicker">
      <div class="hs-datepicker" :class="{'ios-safe-bottom': !isEMobile7Browser}" v-if="currentValue" @click.stop>
        <hs-date-header :title="$t('SelectDate')" @close="_close"/>
        <div class="tips" ref="RefTips" v-if="tips">{{tips}}</div>
        <hs-scroll ref="tableView" class="tableView" :style="`height: calc(100% - 50px - ${_tipsHeight()}px)`">
          <ul>
            <li class="cell" v-for="n in 12" :key="n" :id="`cell${_getMonthBarsMonth(n)}`">
              <div class="moutn-bar">{{$t(`${_getMonthBarsYear(n)}-${_getMonthBarsMonth(n)}`, 'date', ['yyyy年MM月', 'MM yyyy'])}}</div>
              <div class="week-bar">
                <div class="item" v-for="(item, index) in week" :key="index">{{item}}</div>
              </div>
              <div class="day-bar">
                <div class="disabledItem" style="visibility: hidden" v-for="number in _getPreMonthDay(_getMonthBarsYear(n), _getMonthBarsMonth(n))" :key="`pre${number}`">
                  {{number}}
                </div>
                <div v-for="number in _getDayNumber(_getMonthBarsYear(n), _getMonthBarsMonth(n))" :key="`this${number}`"
                     @click="_select(_getMonthBarsYear(n), _getMonthBarsMonth(n), number)"
                     :class="[{weekendItem: _isWeekend(_getMonthBarsYear(n), _getMonthBarsMonth(n), number)},
                (_isOverdue(_getMonthBarsYear(n), _getMonthBarsMonth(n), number) || _addZero(_getMonthBarsYear(n), _getMonthBarsMonth(n), number) > maxToData) ? 'disabledItem' : 'item',
                {thisItem: _isStartDate(_getMonthBarsYear(n), _getMonthBarsMonth(n), number) || (isRangePicker && _isEndDate(_getMonthBarsYear(n), _getMonthBarsMonth(n), number))},
                {rangeItem: isRangePicker && _isRangeDate(_getMonthBarsYear(n), _getMonthBarsMonth(n), number)}]"
                >
                  <!-- 节日 -->
                  <span class="holiday-span no-wrap">{{_setHoliday(_getMonthBarsYear(n), _getMonthBarsMonth(n), number)}}</span>
                  <!-- 日期 -->
                  <div v-if="birthday && _addZero(_getMonthBarsYear(n), _getMonthBarsMonth(n), number).endsWith(birthday)"
                       class="birthday" :style="{backgroundImage: `url(${require('@/assets/image/base/date-picker/birthday.png')})`}">
                  <span v-if="_setRestDay(_getMonthBarsYear(n), _getMonthBarsMonth(n), number)"
                        class="rest" :type="language">{{RestStr}}</span>
                  <span v-if="_setWorkDay(_getMonthBarsYear(n), _getMonthBarsMonth(n), number)"
                          class="work" :type="language">{{WorkStr}}</span>
                  </div>
                  <p v-else>
                     {{_isToday(_getMonthBarsYear(n), _getMonthBarsMonth(n), number) ? TodayStr : number}}
                    <!--{{number}}-->
                    <span v-if="_setRestDay(_getMonthBarsYear(n), _getMonthBarsMonth(n), number)"
                          class="rest" :type="language">{{RestStr}}</span>
                    <span v-if="_setWorkDay(_getMonthBarsYear(n), _getMonthBarsMonth(n), number)"
                          class="work" :type="language">{{WorkStr}}</span>
                  </p>
                  <span v-if="isRangePicker && _isStartDate(_getMonthBarsYear(n), _getMonthBarsMonth(n), number) && _isEndDate(_getMonthBarsYear(n), _getMonthBarsMonth(n), number)"
                        class="holiday-span no-wrap">{{GoAndReturnStr}}</span>
                  <span v-else-if="isRangePicker && _isStartDate(_getMonthBarsYear(n), _getMonthBarsMonth(n), number)"
                        class="holiday-span no-wrap">{{GoingStr}}</span>
                  <span v-else-if="isRangePicker && _isEndDate(_getMonthBarsYear(n), _getMonthBarsMonth(n), number)"
                        class="holiday-span no-wrap">{{ReturnStr}}</span>
                  <!-- 价格 -->
                  <span v-else class="holiday-span no-wrap" style="transform: scale(0.9)">{{_showPrice(_getMonthBarsYear(n), _getMonthBarsMonth(n), number) ? _setPrice(_getMonthBarsYear(n), _getMonthBarsMonth(n), number) : ''}}</span>
                </div>
                <div class="disabledItem" style="visibility: hidden" v-for="number in _getNextMonthDay(_getMonthBarsYear(n), _getMonthBarsMonth(n))" :key="`next${number}`">
                  {{number}}
                </div>
              </div>
            </li>
            <div :style="{height: isRangePicker ? '101px' : '24px'}"></div>
          </ul>
        </hs-scroll>
        <!-- <p class="tip">{{$t('DateIsTheLocalDateOfDepartureCity')}}</p> -->
        <div class="tip">
          <p class="currency-tips" v-if="OrderBusinessType === 1 && !IsChangeOrder && CurrencyInfo && Number(CurrencyInfo.CurrencyType) !== 0 && CurrencyCode">{{$t('CurrencyExplain_x', 'function', [`${CurrencyCode}`])}}</p>
          <div class="details" v-if="isRangePicker">
            <div class="info">
              <p>{{$t('Going')}}: {{currentDate ? $t(currentDate, 'date', ['MM-dd', 'MM dd']) : $t('Unselected')}} {{$t('BackTag')}}: {{currentEndDate ? $t(currentEndDate, 'date', ['MM-dd', 'MM dd']) : $t('Unselected')}}</p>
              <p>{{$t('Total_1')}}<span>{{currentEndDate && datalist.get(currentEndDate) ? $t('CNYStart_x', 'function', [`${amountUnit}${$formatMoney(_getRoundPrice(currentEndDate))}`]) : '--'}}</span></p>
            </div>
            <div class="footer">
              <hs-gradient-button @click="_confirm"
                                  :title="$t('Confirm')"
                                  :type="noValue(currentDate) || noValue(currentEndDate) ? 'disabled-full' : 'full'" height="40px"></hs-gradient-button>
            </div>
          </div>
          <p>{{$t('PromptDatePrice')}}</p>
        </div>
      </div>
    </transition>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from 'vue'
import HsGradientButton from 'base/hs-button/hs-gradient-button'
import HsScroll from 'base/hs-scroll/hs-scroll'
import {kpiRouteLowestPriceGet} from 'api'
import {mapGetters} from 'vuex';
export default {
  props: {
    // 显隐
    value: {
      type: Boolean,
      default: false
    },
    // 标题
    title: {
      type: String,
      default: Vue.prototype.$t('SelectDate')
    },
    // 是否为区间日期选择器
    isRangePicker: {
      type: Boolean,
      default: false
    },
    // 当前选择的日期
    date: {
      type: String,
      default: ''
    },
    // 日期区间选择时的结束日期
    endDate: {
      type: String,
      default: ''
    },
    // 过期日期
    overdueDate: {
      type: String,
      default: Vue.prototype.beTime(new Date())
    },
    // 最大选择天数
    maxToDataDays: {
      type: Number,
      default: 9999
    },
    // 行程信息
    currentTrip: {
      type: Object,
      default: function () {
        return {}
      }
    },
    // 业务板块
    OrderBusinessType: {
      type: Number,
      default: 0
    },
    // 是否为改期订单
    IsChangeOrder: {
      type: Boolean,
      default: false
    },
    tips: { // 火车票提示文案
      type: String,
      default: ''
    },
    // 过期日期
    refundOverdueDate: { // 往返程 返程过期日期
      type: String,
      default: Vue.prototype.beTime(new Date())
    },
    // 最大选择天数
    refundMaxToDataDays: { // 往返程 返程最大可选日期
      type: Number,
      default: 9999
    }
  },
  components: {
    HsGradientButton,
    HsDateHeader: () => import('base/hs-date-picker/hs-date-header'),
    HsClose: () => import('base/hs-close/hs-close'),
    HsScroll
  },
  computed: {
    ...mapGetters([
      'isEMobile7Browser'
    ]),
    amountUnit() {
      return this.CurrencyUnit()
    },
    CurrencyCode() {
      let CurrencyCode = ''
      let CurrencyInfo = JSON.parse(window.localStorage.CurrencyInfo || '')
      if (CurrencyInfo && CurrencyInfo.CurrencyCode) {
        CurrencyCode = CurrencyInfo.CurrencyCode
      } else if (this.CurrencyInfo && this.CurrencyInfo.CurrencySymbol) {
        CurrencyCode = this.CurrencyInfo.CurrencySymbol
      }
      return CurrencyCode
    },
    currentValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        return this.$emit('input', val)
      }
    },
    maxToData() {
      let maxToDataDays = (this.maxToDataDays === null) ? 9999 : this.maxToDataDays
      if (this.currentDate && !this.currentEndDate && this.isRangePicker) {
        maxToDataDays = this.refundMaxToDataDays || maxToDataDays
      }
      let res = this.beTime(new Date().setDate(new Date().getDate() + maxToDataDays - 1)) // 最多选择maxToDataDays天后的日期
      return res
      // getNewDate
    },

    RestStr() {
      return this.$t('Rest')
    },
    WorkStr() {
      return this.$t('Work')
    },
    GoAndReturnStr() {
      return this.$t('GoAndReturn')
    },
    GoingStr() {
      return this.$t('Going')
    },
    ReturnStr() {
      return this.$t('Return')
    },
    TodayStr() {
      return this.$t('Today')
    }
  },
  watch: {
    currentValue(val) {
      setTimeout(() => {
        this.$refs.tableView && this.$refs.tableView.refresh();
        if (val) {
          if (this.OrderBusinessType === 1 && !this.IsChangeOrder && !this.isRangePicker) {
            this._getCalendar()
          } else {
            this.datalist = new Map()
          }
          /** 初始化读取节假日数据 */
          this._getHoliday()

          this.historyFromDate = this.date
          this.historyToDate = this.endDate
          this.currentDate = this.date
          this.currentEndDate = this.endDate

          let res = new Date(this.currentDate).getMonth() + 1
          this.$refs.tableView.scrollToElement(`#cell${res}`, 300)
        }
      }, 20)
    }
  },
  data() {
    return {
      week: [this.$t('WeekSun'), this.$t('WeekMon'), this.$t('WeekTues'), this.$t('WeekWed'), this.$t('WeekThur'), this.$t('WeekFri'), this.$t('WeekSat')],
      monthDay: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      thatYear: new Date().getFullYear(),
      thatMouth: new Date().getMonth(),
      nextYear: new Date().getFullYear() + 1,
      historyFromDate: '',
      historyToDate: '',
      datalist: new Map(), // 价格数据
      calendar: new Map(), // 节假日数据
      calendarRest: new Map(), // 非正常休息日数据
      calendarWork: new Map(), // 非正常工作日数据
      birthday: '',
      currentDate: '',
      currentDatePrice: '',
      currentEndDate: ''
    }
  },
  methods: {
    /** 国内机票获取最低价 */
    _getCalendar(date) {
      let StartDate = date || this.beTime(new Date())
      let EndDate = this.getNewDate(StartDate, 0, 1, 0)
      let params = {
        DepartCode: this.currentTrip && this.currentTrip.DepartObject ? this.currentTrip.DepartObject.AirPortCode : '',
        ArrivalCode: this.currentTrip && this.currentTrip.ArrivalObject ? this.currentTrip.ArrivalObject.AirPortCode : '',
        StartDate: this.beTimeNumber(StartDate),
        EndDate: this.beTimeNumber(EndDate)
      }

      if (this.isRangePicker && date) { // 往返程 且 是去程选择日期后 添加去程价格对象
        params.GoDepartDate = StartDate
      }

      if (this.noValue(params.DepartCode) || this.noValue(params.ArrivalCode)) {
        return
      }
      kpiRouteLowestPriceGet(params).then((res) => {
        console.log('日历: ', res)
        this.datalist = new Map(res.ResultData.map((value, key) => [this.beTime(value.Date), value]))
      })
    },

    /** 初始化读取节假日数据 */
    _getHoliday() {
      if (window.localStorage.CALENDAR) {
        let list = JSON.parse(window.localStorage.CALENDAR)

        // 节假日
        this.calendar = new Map(list.filter(v => v.DayType !== 3).map((value, key) => [this.beTime(value.Date), value]))
        this.calendarRest = new Map(list.filter(v => v.DayType === 1).map((value, key) => [this.beTime(value.Date), value]))
        this.calendarWork = new Map(list.filter(v => v.DayType === 2).map((value, key) => [this.beTime(value.Date), value]))

        // 生日
        let birthday = list.filter(v => v.DayType === 3)
        this.birthday = (birthday && birthday[0]) ? `${this.beTime(birthday[0].Date, 'MM-dd')}` : ''
      }
    },

    /** 设置节日 */
    _setHoliday(year, month, day) {
      let key = this._addZero(year, month, day)
      let res = this.calendar.get(key)
      return res ? res.Title : ''
    },

    /** 设置价格 */
    _setPrice(year, month, day) {
      let key = this._addZero(year, month, day)
      let price = this._getRoundPrice(key)
      return price ? `${price}` : ''
    },

    // 获取往返程最低总价
    _getRoundPrice(key) {
      let res = this.datalist.get(key)
      if (res) {
        return res.LowestPriceDesc
      }
    },

    /** 是否展示价格 */
    _showPrice(year, month, day) {
      return !(this.isRangePicker && !this.noValue(this.currentEndDate) && this._addZero(year, month, day) !== this.currentEndDate)
    },

    /** 设置工作日 */
    _setWorkDay(year, month, day) {
      let key = this._addZero(year, month, day)
      let res = this.calendarWork.get(key)
      return res
    },

    /** 设置休息日 */
    _setRestDay(year, month, day) {
      let key = this._addZero(year, month, day)
      let res = this.calendarRest.get(key)
      return res
    },

    /** 获取某年某月一号的星期数值 */
    _getFirstDayWeek(year, month) {
      return new Date(year, month - 1, 1).getDay()
    },
    /** 获取某年某月最后一天的星期数值 */
    _getLastDayWeek(year, month) {
      return new Date(year, month - 1, this._getDayNumber(year, month)).getDay()
    },
    /** 是否为周末 */
    _isWeekend(year, month, day) {
      let res = new Date(year, month - 1, day).getDay()
      return res === 0 || res === 6
    },
    /** 获取这个月bar中上个月的尾部天数数组 */
    _getPreMonthDay(year, month) {
      let preYear = year
      let preMonth = month
      if (month === 1) {
        preYear--
        preMonth = 12
      } else {
        preMonth--
      }
      let number = this._getDayNumber(preYear, preMonth)
      let length = this._getFirstDayWeek(year, month)
      let list = []
      for (let i = 0; i < length; i++) {
        list.push(number - (length - i) + 1)
      }
      return list
    },
    /** 获取这个月bar中下个月的尾部天数数组 */
    _getNextMonthDay(year, month) {
      let length = 6 - this._getLastDayWeek(year, month)
      let list = []
      for (let i = 0; i < length; i++) {
        list.push(i + 1)
      }
      return list
    },
    /** 根据年月，知道这个月有几天 */
    _getDayNumber(year, month) {
      return this._isLeapYeat(year) && month === 2 ? 29 : this.monthDay[month - 1]
    },
    /** 获取年月栏的年数值 */
    _getMonthBarsYear(n) {
      return (this.thatMouth + n) < 13 ? this.thatYear : this.nextYear
    },
    /** 获取年月栏的月数值 */
    _getMonthBarsMonth(n) {
      return (this.thatMouth + n) < 13 ? (this.thatMouth + n) : (this.thatMouth + n - 12)
    },
    /** 是否为闰年 */
    _isLeapYeat(year) {
      return (year % 100 == 0 ? (year % 400 == 0 ? true : false) : (year % 4 == 0 ? year : false)) // eslint-disable-line
    },
    /** 日期是否已经过期 */
    _isOverdue(year, month, day) {
      let overdueDate = (this.overdueDate === null) ? this.beTime(new Date()) : this.overdueDate
      let that = this._addZero(year, month, day)
      // currentDate currentEndDate refundOverdueDate
      if (this.currentDate && !this.currentEndDate && this.isRangePicker) {
        overdueDate = this.refundOverdueDate || overdueDate
      }
      return that < overdueDate
    },
    /** 是否为选择的日期,用于高亮css */
    _isStartDate(year, month, day) {
      let res = this._addZero(year, month, day)
      return res === this.currentDate
    },
    _isEndDate(year, month, day) {
      let res = this._addZero(year, month, day)
      return res === this.currentEndDate
    },
    /** 是否为今日 */
    _isToday(year, month, day) {
      let res = this._addZero(year, month, day)
      return res === this.beTime(new Date())
    },
    /** 是否为区间日期 */
    _isRangeDate(year, month, day) {
      let res = this._addZero(year, month, day)
      return this.currentDate && res > this.currentDate && res < this.currentEndDate
    },

    _addZero(year, month, day) {
      return `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`
    },

    /** 选择 */
    _select(year, month, day) {
      let res = this._addZero(year, month, day)
      // 普通日期选择器
      if (!this.isRangePicker) {
        this.currentDate = res
        this.$emit('changeDate', this.currentDate)
        this.currentValue = false
      }
      // 区间日期选择器
      if (this.isRangePicker) {
        if (
          !this.noValue(this.currentDate) &&
          this.noValue(this.currentEndDate) &&
          (res >= this.currentDate)
        ) {
          this.currentEndDate = res
        } else {
          this.currentDate = res
          this.currentEndDate = ''
          this._getCalendar(res)
        }
      }
    },

    /** 确认 */
    _confirm() {
      this.$emit('changeDate', this.currentDate, this.currentEndDate)
      this.currentValue = false
    },

    /** 关闭 */
    _close() {
      this.currentDate = this.historyFromDate
      this.currentEndDate = this.historyToDate
      this.currentValue = false
    },

    /** 获取滚动内容部分高度 */
    _tipsHeight() {
      if (this.$refs.RefTips) {
        return this.$refs.RefTips.clientHeight
      }
      return 0
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/popup-mask.styl'
.hs-datepicker
  width 100%
  height 95%
  position fixed
  top 5%
  left 0
  background-color $color_white
  z-index 9
  border-top-left-radius 10px
  border-top-right-radius 10px
  overflow hidden
  &.ios-safe-bottom
    height calc(95% - constant(safe-area-inset-bottom))
    height calc(95% - env(safe-area-inset-bottom))
  >.tips
    @extend .flex-center
    width 100%
    padding 10px
    background $color_yellow_background_warning
    color $color_orange_text_warning
    font-size 12px
    line-height 1.2em
    transition all 500ms
  >.tableView
    width 100%
    height calc(100% - 50px)
    overflow hidden
    .cell
      width 100%
      border-top 10px solid $color_gray_background_0
      padding 10px 0
      >.moutn-bar
        @extend .flex-row
        @extend .flex-start
        width 100%
        height 30px
        font-weight bold
        padding 0 10px
      >.week-bar
        @extend .flex-row
        @extend .flex-between
        width 100%
        border-bottom 1px solid $color_gray_layer
        margin-bottom 2px
        >.item
          @extend .flex-center
          width: 14.28571%
          height 2.5rem
          font-size 0.8rem
      >.day-bar
        @extend .flex-row
        @extend .flex-between
        flex-wrap wrap
        >.disabledItem
        >.item
          @extend .flex-column
          @extend .flex-center
          width: 14.28571%
          height 4rem
          font-size 0.8rem
          >p
            font-size 1rem
            font-weight bold
            margin 3px 0
            position relative
            >.rest
            >.work
              @extend .flex-center
              position absolute
              right -12px
              top 0
              font-size 10px
              color $color_theme
              font-weight bold
              transform scale(0.7)
              transform-origin right
              &[type='EN'],&[type='JAP']
                right -16px
            >.work
              color $color_black_text_0
          >.holiday-span
            font-size 0.7rem
            width 100%
            height 1em
            text-align center
          >.price-span
            font-size 0.7rem
            width 100%
            height 1em
            text-align center
            color $color_black_text_0
          >.birthday
            width 16px
            height 16px
            background-size 100% 100%
            margin 3px 0
            position relative
            >.rest
            >.work
              @extend .flex-center
              position absolute
              right -12px
              transform scale(0.7)
              transform-origin right
              top 0
              font-size 10px
              color $color_theme
              font-weight bold
              &[type='EN'],&[type='JAP']
                right -16px
            >.work
              color $color_black_text_0
        >.disabledItem
          color $color_gray_text !important
          pointer-events none !important
          >p
            >.rest
            >.work
              color $color_gray_text
        >.weekendItem
          color $color_theme
        >.thisItem,
        >.rangeItem
          @extend .flex-column
          @extend .flex-center
          background-color $color_theme
          color $color_white
          border-radius 2px
          >p
            >.rest
            >.work
              color $color_white
          >.price-span
            color $color_white
        >.rangeItem
          background-color $color_red_background_0 !important
          color $color_black_text_0
  >.tip
    position absolute
    left 0
    bottom 0
    width 100%
    >.details
      width 100%
      background-color $color_white
      padding 10px 15px
      // border-top 1px solid $color_gray_layer
      >.info
        @extend .flex-row
        @extend .flex-between
        width 100%
        >p
          @extend .flex-row
          @extend .flex-between
          font-weight bold
          &:nth-child(2)
            >span
              color $color_theme
              font-weight bold
      >.footer
        @extend .flex-center
        width 100%
        margin-top 10px
    >p
      @extend .flex-center
      width 100%
      padding 5px 15px
      background-color $color_gray_background_0
      font-size 0.7rem
      color $color_gray_text
      line-height 1.2em
    >.currency-tips
      background-color $color_yellow_background_warning
      font-size 0.7rem
      color $color_orange_text_warning
.datepicker-enter-active
.datepicker-leave-active
  transition: all 300ms
.datepicker-enter
.datepicker-leave-to
  transform translateY(100%)
</style>
